module.exports = __webpack_public_path__ + "static/media/gal2010-03.8e10af1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-03.jpg
// module id = 556
// module chunks = 0